import React from 'react'
import PropTypes from 'prop-types'
import PageTemplate from 'components/page-template'
import NavTab from './nav-tab'

import Auth from 'services/auth'

const Admin = ({ children }) => (
  <PageTemplate title='Admin Panel' description='management'>
    <NavTab permissions={Auth.permissions} />
    {children}
  </PageTemplate>
)

Admin.displayName = 'Admin'

Admin.propTypes = {
  children: PropTypes.any // eslint-disable-line
}

export default Admin



// WEBPACK FOOTER //
// ./src/pages/admin/index.js